import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import { ISingleFairEvent } from "src/Types/module/FairEvent/FairEventType";
import SingleEventInfoBottom from "../../../../components/FairEventComponents/SingleEventInfoBottom";
import SingleFairEventInfo from "../../../../components/FairEventComponents/SingleFairEventInfo";
import GlobalLoader from "../../../../components/SuspenseLoader/GlobalLoader";
import { useApiQuery } from "src/hooks/useApiQuery";

const SingleEvent = () => {
	const { eventId } = useParams();
	const { data: singleEvent, isLoading } = useApiQuery<ISingleFairEvent>({
		endPoint: `/api/fair/event/${eventId}`,
		queryKeys: ["SingleFairEvent", eventId],
	});

	// useEffect(() => {
	// 	(async function () {
	// 		setLoading(true);
	// 		try {
	// 			const { data } = await axios.get(
	// 				`${url}/api/fair/event/get/single/${eventId}`
	// 			);

	// 			if (data.success) {
	// 				setSingleEvent(data.data);
	// 				setLoading(false);
	// 			} else {
	// 				setLoading(false);
	// 			}
	// 		} catch (error) {
	// 			setLoading(false);
	// 		}
	// 	})();
	// }, [eventId, reload]);

	return (
		<div>
			<Helmet>
				<title>Single Event information</title>
			</Helmet>
			<Container sx={{ mt: 4 }} maxWidth='xl'>
				<Grid
					container
					spacing={{ xs: 2, md: 3 }}
					columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
				>
					{!isLoading ? (
						<>
							{singleEvent && (
								<SingleFairEventInfo
									singleEvent={singleEvent}
								/>
							)}
							<SingleEventInfoBottom
								loading={isLoading}
								eventId={eventId}
							/>
						</>
					) : (
						<GlobalLoader />
					)}
				</Grid>
			</Container>
		</div>
	);
};

export default SingleEvent;
